import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// bootstrapApplication(AppComponent, appConfig).catch((err) =>
//   console.error(err)
// );
function hideLoadingScreen() {
  const loader = document.getElementById('app-loading');
  if (loader) {
    // Wait a bit to ensure Angular has rendered the initial view
    setTimeout(() => {
      loader.classList.add('hide');
      // After transition is complete, remove from DOM
      setTimeout(() => {
        if (loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, 500); // Match to CSS transition time
    }, 300); // Short delay to ensure app content is visible
  }
}

// Set a maximum time the loader can be displayed
const MAX_LOADER_TIME = 10000; // 10 seconds
let loaderTimeout = setTimeout(() => {
  hideLoadingScreen();
}, MAX_LOADER_TIME);

// Bootstrap the application
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // Clear the timeout as app has successfully loaded
    clearTimeout(loaderTimeout);

    // Wait for the next render cycle to ensure content is populated
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        hideLoadingScreen();
      });
    });
  })
  .catch((err) => {
    console.error('Application bootstrap error:', err);
    // Even on error, hide the loading screen
    clearTimeout(loaderTimeout);
    hideLoadingScreen();
  });
